<div style="width: 100%; height: 100%">
    <div *ngIf="modalTitle == 'Create New Pool Point'" [formGroup]="poolForm"
        style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Pool Point Name</mat-label>
                <input matInput formControlName="pool_point_name" placeholder="Start Typing Pool Point Name...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-button-toggle-group name="contactType" [value]="selectedContactType" (change)="onToggleChange($event)">
                <mat-button-toggle value="shipper">Shipper</mat-button-toggle>
                <mat-button-toggle value="consignee">Consignee</mat-button-toggle>
                <mat-button-toggle value="carrier">Carrier</mat-button-toggle>
            </mat-button-toggle-group>
        </span>
        <span *ngIf="selectedContactType == 'shipper'" style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing shipper name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredShipperList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="shipperList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
                <mat-option *ngFor="let type of shipperList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span *ngIf="selectedContactType == 'shipper'" style="flex-basis: 100%;">
            <mat-select [value]="shipperAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of shipperAddresses" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </span>

        <span *ngIf="selectedContactType == 'consignee'" style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing consignee name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredConsigneeList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="consigneeList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
                <mat-option *ngFor="let type of consigneeList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span *ngIf="selectedContactType == 'consignee'" style="flex-basis: 100%;">
            <mat-select [value]="consigneeAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of consigneeAddresses" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </span>

        <span *ngIf="selectedContactType == 'carrier'" style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing carrier name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredCarrierList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="carrierList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
                <mat-option *ngFor="let type of carrierList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span *ngIf="selectedContactType == 'carrier'" style="flex-basis: 100%;">
            <mat-select [value]="carrierAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of carrierAddresses" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </span>
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="createPoolPoint()" color="primary">Create</button>
            <button mat-button (click)="closeModal()" color="accent">Close</button>
        </span>
    </div>
    <div *ngIf="modalTitle == 'Create New Client'" [formGroup]="clientForm"
        style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Client Name</mat-label>
                <input matInput formControlName="pool_point_client_name" placeholder="Start Typing Client Name...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing shipper name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredShipperList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="shipperList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
                <mat-option *ngFor="let type of shipperList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="createClient()" color="primary">Create</button>
            <button mat-button (click)="closeModal()" color="accent">Close</button>
        </span>
    </div>
    <div *ngIf="modalTitle == 'Create New Store'" [formGroup]="storeForm"
        style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Store Number</mat-label>
                <input matInput formControlName="pool_point_store_number" placeholder="Start Typing Store Number...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing consignee name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredConsigneeList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="consigneeList[0]" (selectionChange)="onSelectionConsignee($event)" style="width: 100%;">
                <mat-option *ngFor="let type of consigneeList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span style="flex-basis: 100%;">
            <mat-select [value]="consigneeAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of consigneeAddresses" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </span>
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="createStore()" color="primary">Create</button>
            <button mat-button (click)="closeModal()" color="accent">Close</button>
        </span>
    </div>
    <div *ngIf="modalTitle == 'Switch New Client'" [formGroup]="clientForm"
        style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing shipper name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredShipperList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="shipperList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
                <mat-option *ngFor="let type of shipperList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="switchClient()" color="primary">Save</button>
            <button mat-button (click)="closeModal()" color="accent">Close</button>
        </span>
    </div>
    <div *ngIf="modalTitle == 'Switch New Store'" [formGroup]="storeForm"
        style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <input matInput placeholder="Start typing consignee name.." [matAutocomplete]="auto2"
                    formControlName="new_contact_control">
                <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngFor="let item of filteredConsigneeList | async" [value]="item">
                        <span>{{ item }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-select [value]="consigneeList[0]" (selectionChange)="onSelectionConsignee($event)" style="width: 100%;">
                <mat-option *ngFor="let type of consigneeList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select> -->
        </span>
        <span style="flex-basis: 100%;">
            <mat-select [value]="consigneeAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of consigneeAddresses" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </span>
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="switchStore()" color="primary">Save</button>
            <button mat-button (click)="closeModal()" color="accent">Close</button>
        </span>
    </div>
    <div *ngIf="modalTitle == 'Switch New Pool'" [formGroup]="poolForm"
    style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
    <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 100%;">
            <input matInput placeholder="Start typing contact name.." [matAutocomplete]="auto2"
                formControlName="new_contact_control">
            <mat-autocomplete #auto2="matAutocomplete">
                <mat-option *ngFor="let item of filteredCarrierList | async" [value]="item">
                    <span>{{ item }}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <!-- <mat-select [value]="carrierList[0]" (selectionChange)="onSelectionShipper($event)" style="width: 100%;">
            <mat-option *ngFor="let type of carrierList" [value]="type">
                {{type}}
            </mat-option>
        </mat-select> -->
    </span>
    <span style="flex-basis: 100%;">
        <mat-select [value]="carrierAddresses[0]" (selectionChange)="onSelectionShipperAddress($event)"
            style="width: 100%;">
            <mat-option *ngFor="let type of carrierAddresses" [value]="type">
                {{type}}
            </mat-option>
        </mat-select>
    </span>
    <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
        <button mat-button (click)="switchPool()" color="primary">Save</button>
        <button mat-button (click)="closeModal()" color="accent">Close</button>
    </span>
</div>
</div>